import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ErrorMessageEntityParams {
  messages: string[];
}

export class ErrorMessageEntity extends BaseEntityClass {
  messages: string[];

  constructor(params: ErrorMessageEntityParams) {
    super();
    this.type = "error_message";
    this.entity_version = 2;
    this.messages = params.messages;
  }
}
